// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Cosmos Unchained API
 * Provides access to cosmos chain data.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Contains info about validator unbonding settings
 * @export
 * @interface ValidatorUnbonding
 */
export interface ValidatorUnbonding {
    /**
     * 
     * @type {number}
     * @memberof ValidatorUnbonding
     */
    height: number;
    /**
     * 
     * @type {number}
     * @memberof ValidatorUnbonding
     */
    timestamp: number;
}

/**
 * Check if a given object implements the ValidatorUnbonding interface.
 */
export function instanceOfValidatorUnbonding(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "height" in value;
    isInstance = isInstance && "timestamp" in value;

    return isInstance;
}

export function ValidatorUnbondingFromJSON(json: any): ValidatorUnbonding {
    return ValidatorUnbondingFromJSONTyped(json, false);
}

export function ValidatorUnbondingFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidatorUnbonding {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'height': json['height'],
        'timestamp': json['timestamp'],
    };
}

export function ValidatorUnbondingToJSON(value?: ValidatorUnbonding | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'height': value.height,
        'timestamp': value.timestamp,
    };
}

